import {Subject} from 'rxjs';
import {isString} from 'lodash';
import { AlertTypes, AlertPositions } from '../Constants';

export class AlertFactory{
    _alert = new Subject()
    _getAlerts = () => this._alert.asObservable()


    default = (message, actionConfig, anchorOrigin = AlertPositions.bottomLeft) => {
      if(!isString(message)){
        message = JSON.stringify(message)
      }
      this._alert.next({message, actionConfig, variant: AlertTypes.default, anchorOrigin})
    }
    info = (message, actionConfig, anchorOrigin = AlertPositions.bottomLeft) => {
      if(!isString(message)){
        message = JSON.stringify(message)
      }
      this._alert.next({message, actionConfig, variant: AlertTypes.info, anchorOrigin})
    }
    warning = (message, actionConfig, anchorOrigin = AlertPositions.bottomLeft) => {
      if(!isString(message)){
        message = JSON.stringify(message)
      }
      this._alert.next({message, actionConfig, variant: AlertTypes.warning, anchorOrigin})
    }
    error = (message, actionConfig, anchorOrigin = AlertPositions.bottomLeft) => {
      if(!isString(message)){
        message = JSON.stringify(message)
      }
      this._alert.next({message, actionConfig, variant: AlertTypes.error, anchorOrigin})
    }
    success = (message, actionConfig, anchorOrigin = AlertPositions.bottomLeft) => {
      if(!isString(message)){
        message = JSON.stringify(message)
      }
      this._alert.next({message, actionConfig, variant: AlertTypes.success, anchorOrigin})
    }
    alert = (title, message, actionConfig) => this.warning(message, actionConfig)
  
  
}

export const Alert = new AlertFactory()